export default __webpack_public_path__ + "static/media/buyNGetMCheapestAtDiscount.e44caf00.png";